import {
  __decorateClass
} from "./chunk-QUKACBNK.js";

// src/components/side-nav.ts
import {
  html as html2,
  LitElement as LitElement2
} from "@spectrum-web-components/base";
import {
  customElement as customElement2,
  property as property2
} from "@spectrum-web-components/base/src/decorators.js";

// src/components/side-nav-search.ts
import {
  html,
  LitElement
} from "@spectrum-web-components/base";
import {
  customElement,
  property,
  query
} from "@spectrum-web-components/base/src/decorators.js";

// src/components/side-nav-search.css
import { css } from "lit";
var styles = css`:host{display:block}sp-search{width:100%;--spectrum-alias-single-line-width:100%}#search-results-menu{width:250px;max-height:calc(100vh - 200px);flex-direction:column;display:flex}sp-illustrated-message{color:var(--spectrum-gray-800);flex:1;margin-bottom:2em}`;
var side_nav_search_default = styles;

// src/components/side-nav-search.ts
import "@spectrum-web-components/overlay/sp-overlay.js";
import "@spectrum-web-components/search/sp-search.js";
var stopPropagation = (event) => event.stopPropagation();
var SearchComponent = class extends LitElement {
  constructor() {
    super(...arguments);
    this.open = false;
    this.results = [];
  }
  static get styles() {
    return [side_nav_search_default];
  }
  focus() {
    this.searchField.focus();
  }
  handleSearchPointerdown() {
    const abortController = new AbortController();
    const { signal } = abortController;
    const handlePointerup = () => {
      this.overlayEl.manuallyKeepOpen();
    };
    const cleanup = () => abortController.abort();
    this.searchField.addEventListener("pointerup", handlePointerup, {
      signal
    });
    document.addEventListener("pointerup", cleanup, {
      signal
    });
    document.addEventListener("pointercancel", cleanup, {
      signal
    });
  }
  handleKeydown(event) {
    const { code } = event;
    const shouldFocusResultsList = code === "ArrowDown" || code === "ArrowUp";
    if (!shouldFocusResultsList) {
      return;
    } else {
      event.preventDefault();
    }
    this.focusResults({ shouldFocusResultsList });
  }
  async focusResults({
    shouldFocusResultsList
  }) {
    if (shouldFocusResultsList) {
      this.menuEl.addEventListener(
        "focus",
        () => {
          this.menuEl.childItems[this.menuEl.focusedItemIndex].focused = true;
        },
        {
          once: true
        }
      );
      this.menuEl.focus();
    } else {
      this.popoverEl.focus();
    }
  }
  openPopover() {
    this.open = true;
  }
  closePopover() {
    this.open = false;
  }
  handleSubmit(event) {
    event.preventDefault();
    if (this.results.length < 0) {
      return;
    }
    this.menuEl.focus();
  }
  async updateSearchResults() {
    const { value } = this.searchField;
    if (value.length < 3 || !this.searchField.focused) {
      this.closePopover();
      return false;
    }
    const searchParam = `${value.trim()}*`;
    const search = await import("./search-index-JI5XPDCT.js").then(
      ({ search: search2 }) => search2
    );
    this.results = await search(searchParam);
    this.openPopover();
    return this.results.length > 0;
  }
  handleMenuFocusout(event) {
    if (!this.menuEl.contains(event.relatedTarget)) {
      this.menuEl.childItems.forEach((item) => {
        item.focused = false;
      });
    }
  }
  renderResults() {
    if (this.results.length > 0) {
      return html`
                <sp-menu tabindex="-1" @focusout=${this.handleMenuFocusout}>
                    ${this.results.map(
        (category) => html`
                            <sp-menu-group>
                                <span slot="header">${category.name}</span>
                                ${category.results.map(
          (result) => html`
                                        <sp-menu-item href="${result.url}">
                                            ${result.label}
                                        </sp-menu-item>
                                    `
        )}
                            </sp-menu-group>
                        `
      )}
                </sp-menu>
            `;
    } else {
      return html`
                <sp-illustrated-message
                    heading="No results found"
                    description="Try another search term."
                ></sp-illustrated-message>
            `;
    }
  }
  render() {
    return html`
            <div id="search-container">
                <sp-search
                    id="search"
                    @pointerdown=${this.handleSearchPointerdown}
                    @focusin=${this.updateSearchResults}
                    @input=${this.updateSearchResults}
                    @change=${this.updateSearchResults}
                    @keydown=${this.handleKeydown}
                    @click=${stopPropagation}
                    @submit=${this.handleSubmit}
                    autocomplete="off"
                ></sp-search>
                <sp-overlay
                    ?open=${this.open}
                    placement="bottom-start"
                    receives-focus="false"
                    trigger="search"
                    type="auto"
                >
                    <sp-popover id="search-results-menu">
                        ${this.renderResults()}
                    </sp-popover>
                </sp-overlay>
            </div>
        `;
  }
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    this.addEventListener("blur", this.closePopover);
  }
};
__decorateClass([
  query("sp-menu")
], SearchComponent.prototype, "menuEl", 2);
__decorateClass([
  property({ type: Boolean })
], SearchComponent.prototype, "open", 2);
__decorateClass([
  query("sp-overlay")
], SearchComponent.prototype, "overlayEl", 2);
__decorateClass([
  query("sp-popover")
], SearchComponent.prototype, "popoverEl", 2);
__decorateClass([
  query("sp-search")
], SearchComponent.prototype, "searchField", 2);
__decorateClass([
  property({ type: Array })
], SearchComponent.prototype, "results", 2);
SearchComponent = __decorateClass([
  customElement("docs-search")
], SearchComponent);

// src/components/side-nav.css
import { css as css2 } from "lit";
var styles2 = css2`::slotted(*){width:100%}aside{max-height:100vh;height:100vh;background-color:var(--spectrum-gray-75);flex-direction:column;display:flex;position:sticky;top:0;left:0;overflow:auto}@media screen and (max-width:960px){aside{transition:transform var(--spectrum-dialog-confirm-background-entry-animation-duration,var(--spectrum-animation-duration-600))cubic-bezier(0,0,.4,1),visibility 0s linear var(--spectrum-animation-duration-600);z-index:10;min-height:100vh;visibility:hidden;position:fixed;top:0;left:0;transform:translate(-100%)}[dir=rtl]+aside{visibility:hidden;left:auto;right:0;transform:translate(100%)}:host([open]) aside{visibility:visible;transition-delay:0s,0s;transform:translate(0)}.scrim{z-index:10;touch-action:none}}#nav-header a,#nav-header a:visited{color:var(--spectrum-gray-800);text-decoration:none}.navigation{width:calc(var(--swc-scale-factor)*240px - 48px);flex:1;padding:0 24px 24px;overflow:hidden auto}docs-spectrum-logo{width:36px;height:32px;padding-top:7px;display:block}:host([dir=ltr]) docs-spectrum-logo{margin-right:16px}:host([dir=rtl]) docs-spectrum-logo{margin-left:16px}#logo-container{border-radius:4px;outline:none}docs-search{width:calc(var(--swc-scale-factor)*192px);padding:0 calc(var(--swc-scale-factor)*24px)calc(var(--swc-scale-factor)*24px)calc(var(--swc-scale-factor)*24px)}sp-sidenav{width:100%}.spectrum-web{margin-top:80px;display:block}sp-underlay:not(:defined){opacity:0}`;
var side_nav_default = styles2;

// src/components/side-nav.ts
import "@spectrum-web-components/sidenav/sp-sidenav.js";
import "@spectrum-web-components/sidenav/sp-sidenav-item.js";
import "@spectrum-web-components/underlay/sp-underlay.js";
var SideNav = class extends LitElement2 {
  constructor() {
    super(...arguments);
    this.open = false;
    this.isNarrow = false;
  }
  static get styles() {
    return [side_nav_default];
  }
  toggle() {
    this.open = !this.open;
  }
  focus() {
    const target = document.querySelector(
      '[slot="logo"]'
    );
    if (!target) {
      this.shadowRoot.querySelector("#logo").focus();
      return;
    }
    target.focus();
  }
  handleTransitionEvent(event) {
    this.dispatchEvent(new TransitionEvent(event.type));
  }
  render() {
    return html2`
            ${this.isNarrow ? html2`
                      <sp-underlay
                          class="scrim"
                          @close=${this.toggle}
                          ?open=${this.open}
                          @transitionrun=${this.handleTransitionEvent}
                          @transitionend=${this.handleTransitionEvent}
                          @transitioncancel=${this.handleTransitionEvent}
                      ></sp-underlay>
                  ` : html2``}
            <aside
                @transitionrun=${this.handleTransitionEvent}
                @transitionend=${this.handleTransitionEvent}
                @transitioncancel=${this.handleTransitionEvent}
            >
                <div id="nav-header">
                    <div id="logo-container">
                        <slot name="logo"></slot>
                    </div>
                    <docs-search></docs-search>
                </div>
                <div class="navigation">
                    <slot></slot>
                </div>
            </aside>
        `;
  }
  updated(changes) {
    if (changes.has("open")) {
      if (!this.open && changes.get("open")) {
        this.dispatchEvent(new Event("close", { bubbles: true }));
      }
    }
  }
};
__decorateClass([
  property2({ type: Boolean, reflect: true })
], SideNav.prototype, "open", 2);
__decorateClass([
  property2({ type: Boolean })
], SideNav.prototype, "isNarrow", 2);
SideNav = __decorateClass([
  customElement2("docs-side-nav")
], SideNav);
export {
  SideNav
};
